import { render, staticRenderFns } from "./DisputeViewDigitalGoods.vue?vue&type=template&id=d5d79b1a&"
import script from "./DisputeViewDigitalGoods.vue?vue&type=script&lang=js&"
export * from "./DisputeViewDigitalGoods.vue?vue&type=script&lang=js&"
import style0 from "./DisputeViewDigitalGoods.vue?vue&type=style&index=0&id=d5d79b1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports